import { render } from "./VidioPlayer.vue?vue&type=template&id=330665da&scoped=true"
import script from "./VidioPlayer.vue?vue&type=script&lang=js"
export * from "./VidioPlayer.vue?vue&type=script&lang=js"

import "./VidioPlayer.vue?vue&type=style&index=0&id=330665da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330665da"]])

export default __exports__